
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { BuscarFolioParams, BuscarFolioResponse, GenerarExhortoRecibidoParams, GenerarExhortoRecibidoResponse, GenerarExpedienteParams, GenerarExpedienteResponse } from '../../interfaces/comun/FolioInterface';

export const BuscarFolio = ( params: BuscarFolioParams ) => {

    return new Promise<BuscarFolioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Folio/BuscarFolio', params, token)
            .then( ({ data } : { data : BuscarFolioResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idFolio: 0, 
                    numeroFolio: '', 
                    numeroExpediente: '', 
                    numeroExhortoRecibido: '', 
                    tipoJuicio: '', 
                    tipoCalificacion: '', 
                    generarExpediente: false,
                    observaciones: '',
                    esExhorto: false,
                    partes: [],
                    cuantia: '',
                });
            });
        }

    });

}

export const GenerarExhortoRecibido = ( params: GenerarExhortoRecibidoParams ) => {

    return new Promise<GenerarExhortoRecibidoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Folio/GenerarExhortoRecibido', params, token)
            .then( ({ data } : { data : GenerarExhortoRecibidoResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idFolio: 0, 
                    numeroFolio: '', 
                    numeroExpediente: '', 
                    numeroExhortoRecibido: '', 
                    tipoJuicio: '', 
                    tipoCalificacion: '', 
                    generarExpediente: false,
                    observaciones: '',
                    esExhorto: false,
                    partes: [],
                    cuantia: '',
                });
            });
        }

    });

}

export const GenerarExpediente = ( params: GenerarExpedienteParams ) => {

    return new Promise<GenerarExpedienteResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Folio/GenerarExpediente', params, token)
            .then( ({ data } : { data : GenerarExpedienteResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idFolio: 0, 
                    numeroFolio: '', 
                    numeroExpediente: '', 
                    numeroExhortoRecibido: '', 
                    tipoJuicio: '', 
                    tipoCalificacion: '', 
                    generarExpediente: false,
                    observaciones: '',
                    esExhorto: false,
                    partes: [],
                    cuantia: '',
                });
            });
        }

    });

}